import React from 'react'
import * as Constants from '../atributoDinamico/constants.js'
import Timezone from '../../commons/timezone/Timezone.js'

// VEC-3637: layout de 2 líneas para una decisión ya persistida (ultima_validacion vigente),
// compartido entre ValidacionGranularModal (fila interactiva) y ValidacionGranularSeccionReadOnly
// (detalle de solo lectura), para que el fix del truncado sin `title` no diverja entre ambos.
export function formatoMotivo(motivo, intl) {
	let texto = motivo ? motivo : intl.formatMessage({ id: 'formularios.validacionGranular.sin_comentario', defaultMessage: 'Sin comentario' })
	return ' (' + texto + ')'
}

export default function EstadoDecisionAuditor(props) {
	let vigente = props.vigente
	let intl = props.intl
	let claseColor = vigente.decision === Constants.ID_DECISION_INVALIDO ? 'danger' : 'success'

	let decisionLabel = vigente.decision === Constants.ID_DECISION_VALIDO
		? intl.formatMessage({ id: 'formularios.validacionGranular.decision_valido_label', defaultMessage: 'Validado' })
		: intl.formatMessage({ id: 'formularios.validacionGranular.decision_invalido_label', defaultMessage: 'Rechazado' })
	let resultado = decisionLabel + formatoMotivo(vigente.motivo, intl)

	let usuarioFecha = intl.formatMessage(
		{ id: 'formularios.validacionGranular.estado_decision_usuario_fecha', defaultMessage: '{usuario} el {fecha}' },
		{
			usuario: vigente.usuario_validador ? vigente.usuario_validador.nombre : '',
			fecha: Timezone.getDateForClient(vigente.created_at, null, 'DD/MM/YYYY HH:mm'),
		}
	)

	return (
		<div>
			<div className="text-truncate" title={resultado}>
				<small className={claseColor}>{resultado}</small>
			</div>
			<div className="text-truncate" title={usuarioFecha}>
				<small className={claseColor}>{usuarioFecha}</small>
			</div>
		</div>
	)
}
